import { Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import _ from "lodash";

const AddMoreInformationField = props => {

    const [utils, setUtils] = useState({ label: "", value: "" });

    return (
        <>
            <Row className="p-2 text-center">
                <Col md={6} xs={6} lg={6} sm={6} xl={6} className='text-left'>
                    <input className="w-100 text-center" onChange={(e) => setUtils({ ...utils, label: e.target.value })}
                        style={{"border": "none", "borderBottom": "1px solid #075978"}} placeholder="Enter Label"/>
                </Col>
                <Col md={6} xs={6} lg={6} sm={6} xl={6} className="text-right">
                    <input className="w-100 text-center" onChange={(e) => setUtils({ ...utils, value: e.target.value })}
                        style={{"border": "none", "borderBottom": "1px solid #075978"}} placeholder="Enter Value" />
                    <Icon style={{"marginTop": "10px", "marginRight": "5px", "cursor": "pointer"}} onClick={() => props.onCancel()}
                        width={20} height={20} color="text-color-grey" icon={"feather-x"} />
                    { 
                        !_.isEmpty(utils.label) && !_.isEmpty(utils.value) &&
                        <Icon onClick={() => props.addInformation(utils.label, utils.value)} 
                            style={{"marginTop": "10px", "cursor": "pointer"}} width={20} height={20} color="text-primary" icon={"feather-check"} />
                    }
                </Col>
            </Row>
        </>
    )

}
export default AddMoreInformationField;